import styled from 'styled-components';
export var TitleBlock = styled.div.withConfig({
  displayName: "Title__TitleBlock",
  componentId: "sc-ec8rv4-0"
})(["height:32px;"]);
export var Title = styled.h5.withConfig({
  displayName: "Title",
  componentId: "sc-ec8rv4-1"
})(["display:block;font-size:14px;font-weight:700;line-height:16px;color:", ";"], function (_ref) {
  var theme = _ref.theme;
  return theme.colors.terciaryD;
});